import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import {
  Dialog,
  CircularProgress,
  DialogContent,
  DialogContentText,
  Typography,
  // Divider,
} from '@material-ui/core';

import Alert from '../../common/components/Alert';
import FormErrorDialog from '../../common/components/formErrorDialog';
import SocialLoginButtons from './SocialLoginButtons';
import OtpLoginForm from './OtpLoginForm';
import * as authActions from '../actions';

import * as routes from '../../config/routes';
import classes from '../../css/getCSS';

const OTP_VALIDITY_SECONDS = 300;


class LoginModal extends Component {
  state = {
    countdown: 0,
  };

  countdownInterval = null;

  componentDidUpdate(prevProps) {
    if (prevProps.loginModalOpen && !this.props.loginModalOpen) {
      this.clearCountdown();
      this.props.setOtpSent(false);
      this.props.resetOtpForm();
      this.props.clearAuthErrors();
    }

    if (!prevProps.otpSent && this.props.otpSent) {
      this.startCountdown();
    }
  }

  componentWillUnmount() {
    this.clearCountdown();
    this.props.onUnmount();
  }

  startCountdown = () => {
    this.clearCountdown();
    this.setState({ countdown: OTP_VALIDITY_SECONDS });
    this.countdownInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.countdown <= 1) {
          this.clearCountdown();
          this.props.setOtpSent(false);
          this.props.clearOtpField();
          return { countdown: 0 };
        }
        return { countdown: prevState.countdown - 1 };
      });
    }, 1000);
  };

  clearCountdown = () => {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    this.setState({ countdown: 0 });
  };

  responseGoogle = (response) => {
    this.props.doSocialLogin(
      'google-oauth2',
      response,
      this.props.site.id,
      this.props.isSignup,
    );
  }

  responseFacebook = (response) => {
    this.props.doSocialLogin(
      'facebook',
      response,
      this.props.site.id,
      this.props.isSignup,
    );
  }

  navigateToLogin = () => {
    this.props.history.push(routes.LOGIN);
  }

  inputChangedHandler = (event, field) => {
    if (field === 'email' && this.props.otpSent) {
      return;
    }

    let sanitizedEvent = event;

    if (field === 'otp' && event && event.target) {
      const currentValue = event.target.value || '';
      const lastChar = currentValue.slice(-1);
      let otpValue = currentValue;

      if (lastChar && !/^\d$/.test(lastChar)) {
        otpValue = currentValue.slice(0, -1);
      } else {
        otpValue = currentValue.replace(/\D/g, '');
      }
      sanitizedEvent = otpValue.slice(0, 6);
    }

    this.props.inputChangedHandler(
      sanitizedEvent,
      field,
      'otpLoginForm',
      this.props.otpInputs,
    );
  }

  submitHandler = (event) => {
    event.preventDefault();

    if (this.props.otpSent) {
      this.props.doOtpLoginHandler(
        'otpLoginForm',
        this.props.otpInputs,
        this.props.executeRecaptcha,
        this.props.site.id,
        this.props.isSignup,
      );
    } else {
      this.props.sendOtpHandler(
        'otpLoginForm',
        this.props.otpInputs,
        this.props.executeRecaptcha,
        this.props.isSignup,
      );
    }
  }

  render() {
    let errorAlert = null;
    if (this.props.hasError) {
      errorAlert = <Alert type="danger">An error occured while trying to login in</Alert>;
    }

    let otpForm = (
      <form method="post" onSubmit={this.submitHandler}>
        <OtpLoginForm
          inputs={this.props.otpInputs}
          inputChangedHandler={this.inputChangedHandler}
          otpSent={this.props.otpSent}
          countdown={this.state.countdown}
        />
      </form>
    );

    let socialButtons = (
      <div align="center">
        <SocialLoginButtons
          responseGoogle={this.responseGoogle}
          responseFacebook={this.responseFacebook}
          isSignup={this.props.isSignup}
        />
      </div>
    );

    if (this.props.loading) {
      otpForm = (
        <div align="center">
          <CircularProgress align="center" size={50} />
        </div>
      );
      socialButtons = null;
    }

    let modalTitle = 'Sign in with Lohana Connect';
    if (this.props.isSignup) {
      modalTitle = 'Sign up with Lohana Connect';
    }

    let errors = null;
    if (this.props.errors && this.props.errors.length) {
      errors = this.props.errors.map((error, i) => {
        return (<Alert key={i} type="danger"><span dangerouslySetInnerHTML={{ __html: error }} /></Alert>); // eslint-disable-line
      });
    }

    return (
      <React.Fragment>
        <Dialog
          maxWidth="sm"
          fullWidth
          open={this.props.loginModalOpen}
          onClose={this.props.handleClose}
          aria-labelledby="login-dialog-title"
          aria-describedby="login-dialog-description"
          classes={{
            paper: classes.dialogCard,
          }}
        >
          <DialogContent>
            <DialogContentText style={{ textAlign: 'center', fontSize: '1.2rem', fontWeight: 'bold' }} justify="center">{modalTitle}</DialogContentText>
            <br />
            {errorAlert}
            {errors}
            <br />
            {otpForm}
            {/*{!this.props.loading && (*/}
            {/*  <React.Fragment>*/}
            {/*    <br />*/}
            {/*    <Divider />*/}
            {/*    <br />*/}
            {/*    <Typography variant="body2" style={{ textAlign: 'center', color: '#666', marginBottom: '12px' }}>*/}
            {/*      Or continue with*/}
            {/*    </Typography>*/}
            {/*    {socialButtons}*/}
            {/*  </React.Fragment>*/}
            {/*)}*/}
            <br /><br />
            <Typography style={{ color: "red" }} variant="subheading">
              To continue, please create your account on the <a href="https://connect.lohanamahaparishad.org">Lohana Connect</a> first.
            </Typography>
            <Typography variant="body1">For any technical problems contact lagnasetu@lohanamahaparishad.org</Typography>
          </DialogContent>
        </Dialog>
        <FormErrorDialog
          open={this.props.hasError}
          handleClose={this.props.toggleError}
        />
      </React.Fragment>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    loading: state.auth.loading,
    hasError: state.auth.hasError,
    errors: state.auth.errors,
    otpInputs: state.auth.otpLoginForm,
    otpSent: state.auth.otpSent,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doSocialLogin: (type, response, siteID, isSignup) => dispatch(
      authActions.doSocialLogin(type, response, siteID, null, null, isSignup),
    ),
    sendOtpHandler: (form, inputs, executeRecaptcha, isSignup) => dispatch(
      authActions.sendOtpHandler(form, inputs, executeRecaptcha, isSignup),
    ),
    doOtpLoginHandler: (form, inputs, executeRecaptcha, siteID, isSignup) => dispatch(
      authActions.doOtpLoginHandler(form, inputs, executeRecaptcha, siteID, isSignup),
    ),
    inputChangedHandler: (event, field, form, inputs) => dispatch(
      authActions.inputChangedHandler(event, field, form, inputs),
    ),
    setOtpSent: (sent) => dispatch(authActions.setOtpSent(sent)),
    resetOtpForm: () => dispatch(authActions.resetForm('otpLoginForm')),
    clearOtpField: () => dispatch(authActions.clearOtpField()),
    clearAuthErrors: () => dispatch(authActions.clearAuthErrors()),
    toggleError: () => dispatch(authActions.toggleError()),
    onUnmount: () => dispatch(authActions.onUnmount()),
  };
};

const ConnectedLoginModal = withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginModal));

export default function LoginModalWrapper(props) {
  const { executeRecaptcha } = useGoogleReCaptcha();
  return <ConnectedLoginModal {...props} executeRecaptcha={executeRecaptcha} />;
}




// WEBPACK FOOTER //
// ./src/auth/components/LoginModal.js